<div class="module-wrapper content-wrapper">
  <mat-card>
    <mat-card-content>
      <div class="head-container">
        <h1>{{'assessment.heading' | translate}}</h1>
      </div>
      <div class="itemBtn">
        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button class="btn-primary" aria-label="Assign Assessment" (click)="onAssignAssessment()">
              {{'assessment.assignAssessment' | translate}}</button>
          </div>
        </div>
      </div>
      <br>
      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper invalid" *ngIf="assignedRole == accountAdmin">
            <select aria-placeholder="Center" [(ngModel)]="Center" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model=""
            (change)="onSelectCenter($event)">
              <option value="0" selected>{{'assessment.patientList.center' | translate}}</option>
              <option *ngFor="let s of CenterList" [value]="s" >{{s}}</option>
            </select>
          </div>

          <div class="input-wrapper invalid" *ngIf="assignedRole == accountAdmin">
            <select aria-placeholder="doctor" [(ngModel)]="doctorName" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="0" selected>{{'assessment.patientList.doctorName' | translate}}</option>
              <option *ngFor="let s of doctorListOptions" [value]="s.doctorId">{{s.doctorName}}</option>
            </select>
          </div>

          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'assessment.patientList.patientName' | translate}}" [(ngModel)]="patientName" class="form-control ng-untouched ng-pristine ng-valid"
            ng-reflect-model="" filterValidator="patientName">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'assessment.patientList.phone' | translate}}" [(ngModel)]="phone" class="form-control ng-untouched ng-pristine ng-valid"
            ng-reflect-model="" filterValidator="phone">
          </div>
          <div class="input-wrapper">
            <select aria-placeholder="Status" [(ngModel)]="assessmentstatusid" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="0" selected>{{'assessment.patientList.assessmentStatus' | translate}}</option>
              <option *ngFor="let s of assessmentStatusList" [value]="s.id">{{s.title}}</option>
            </select>
          </div>

          <div class="btn-wrapper">
            <button mat-flat-button class="btn-primary" (click)="searchFilter()" aria-label="Search">{{'assessment.patientList.btnSearch' | translate}}</button>
            <button mat-flat-button class="btn-flat" (click)="resetFilter()" aria-label="Reset">{{'assessment.patientList.btnReset' | translate}}</button>
          </div>
        </div>
      </div>

      <div *ngIf="isDataNotFound" class="data-not-found-container table-container">
        <span>{{'assessment.patientList.errMsg1' | translate}}</span>
      </div>
      <div class="table-container d-none" [class.d-block]="dataSource" *ngIf="!isDataNotFound">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container *ngFor="let col of dynamicColumns" [matColumnDef]="col.key" >
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{col.value}}</th>
            <td mat-cell *matCellDef="let row" (click)="navogateTopatientDetails(row)">{{row[col.key]}}</td>
          </ng-container>

          <ng-container matColumnDef="patientName">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.patientList.column1' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="navogateTopatientDetails(row)">{{row.patientName}}</td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.patientList.column2' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="navogateTopatientDetails(row)">{{row.countryCode}}{{row.phone}}</td>
          </ng-container>

          <ng-container matColumnDef="assessmentstatus">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.patientList.column3' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="navogateTopatientDetails(row)">{{row.assessmentStatus}}</td>
          </ng-container>

          <ng-container matColumnDef="assessmentstartdate">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.patientList.column4' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="navogateTopatientDetails(row)">{{row.assessmentStartDate}}</td>
          </ng-container>

          <ng-container matColumnDef="patientcategory">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.patientList.column5' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="navogateTopatientDetails(row)">{{row.patientCategory}}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'assessment.patientList.column6' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="onEdit(row)" matTooltip="{{'assessment.patientList.toolTip.edit' | translate}}">
                <mat-icon>edit</mat-icon>
              </button>

              <button mat-icon-button [ngClass]="{'disableIcon': row.a1StatusId != AssessmentStatusIds.notStarted || row.isVerified}"
              [disabled]="row.a1StatusId != AssessmentStatusIds.notStarted || row.isVerified" (click)="onResendOTP(row)" matTooltip="{{'assessment.patientList.toolTip.resendOtp' | translate}}">
                <mat-icon>autorenew</mat-icon>
              </button>

              <button mat-icon-button [ngClass]="{'disableIcon': row.a1StatusId != AssessmentStatusIds.notStarted}"
                [disabled]="row.a1StatusId != AssessmentStatusIds.notStarted" (click)="onResendSMS(row)" matTooltip="{{'assessment.patientList.toolTip.resendSMS' | translate}}">
                <mat-icon> mail_outline</mat-icon>
              </button>

              <button mat-icon-button class="color" [ngClass]="{'disableIcon': row.a1StatusId == AssessmentStatusIds.notStarted}"
              [disabled]="row.a1StatusId == AssessmentStatusIds.notStarted" (click)="exportToPDF(row)" matTooltip="{{'reports.detailedTestReport.export' | translate}}">
                <mat-icon>save_alt</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="patient-paginator d-none"  [class.d-block]="dataSource" *ngIf="!isDataNotFound">
        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div class="isViewPDF">
  <div class="logos">
    <img *ngIf="configService.themeConfig.ImgUrl" [src]="configService.themeConfig.ImgUrl" alt="" width="180">
      <!-- <img *ngIf="configService.themeConfig.svaslogoUrl" [src]="configService.themeConfig.svaslogoUrl" alt="" width="150"> -->
  </div>
  <br>
  <div class="header">
    <div class="patient-details">
      <div class="patient-name"><strong>{{'reports.patientReport.patientName' | translate}}: {{patientData?.patientName}} </strong></div>
      <div>{{'reports.patientReport.Patientphone' | translate}}: {{patientData?.countryCode}}{{patientData?.phone}} </div>
      <div>{{'reports.patientReport.Center' | translate}}: {{patientData?.center}} </div>
    </div>
  </div>
  <br>

  <div class="table-container d-none" [class.d-block]="dataSource1">
    <table mat-table [dataSource]="dataSource1" matSort class="mat-elevation-z8" #table>
      <ng-container matColumnDef="AssessmentName">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
          {{'reports.patientReport.column1' | translate}}
          <br>{{'reports.patientReport.column11' | translate}}
        </th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.scheduleCode != scheduleCodeEnum.A5 && row.scheduleCode != scheduleCodeEnum.A7 && scheduleCodeEnum.A8">{{row.assessmentName}}</span>
          <span *ngIf="row.scheduleCode == scheduleCodeEnum.A5">{{row.assessmentName}} {{'reports.patientReport.seconds' | translate}}</span>
          <span *ngIf="row.scheduleCode == scheduleCodeEnum.A7">{{row.assessmentName}} {{'reports.patientReport.kgm' | translate}} <sup>2</sup>)</span>
          <span *ngIf="row.scheduleCode == scheduleCodeEnum.A8">{{row.assessmentName}} {{'reports.patientReport.numberofTablets' | translate}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="AssessmentType">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
          {{'reports.patientReport.column2' | translate}}
          <br>{{'reports.patientReport.column22' | translate}}
        </th>
        <td mat-cell *matCellDef="let row">{{row.assessmentType}}</td>
      </ng-container>

      <ng-container matColumnDef="AssessmentStatus">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
          {{'reports.patientReport.column3' | translate}}
          <br>{{'reports.patientReport.column33' | translate}}
        </th>
        <td mat-cell *matCellDef="let row">{{row.assessmentStatus}}</td>
      </ng-container>

      <ng-container matColumnDef="TimeTaken">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" style="width: 15%">{{'reports.patientReport.column4' | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.scheduleDuration}}</td>
      </ng-container>

      <ng-container matColumnDef="score">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.patientReport.column5' | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.score}}</td>
      </ng-container>

      <ng-container matColumnDef="inference">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.patientReport.column6' | translate}}</th>
        <td mat-cell *matCellDef="let row" style="width: 20%">
          <span [innerHTML]="row.inference"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'reports.patientReport.column7' | translate}}</th>
        <td mat-cell *matCellDef="let row">{{row.oldRemarks}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
      <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
    </table>
  </div>
</div>

